<template>
  <div class="home_channel_zone" v-if="list.length">
    <div class="scroll_row hide_scrollbar f0">
      <div class="scroll_inner">
        <div
          v-for="(item, index) in list"
          :key="'ch-' + index"
          class="channel_card"
          ref="cardEls"
          @click="cardHandle(item, index)"
        >
          <div class="channel_img_wrap">
            <img
              class="channel_img radius-8px"
              :src="item.img_path || '/static/images/errorimg.jpg'"
              :alt="item.ad_title || ''"
              @error="onImgError"
            />
            <div
              :path="
                (item.ad_target || '') +
                (String(item.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                'sorce=8'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="is_wx && (item.ad_type == 7 || item.ad_type == 8)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeixin } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'

/**
 * 频道专区 channelZone（ajax.js）
 * 单项：ad_title, img_path, ad_type, ad_target, roomid, liveid, liveroom_qrcode_url,
 * height, width, finderUserName
 * 一屏展示 3 张，多于 3 张横向滑动，隐藏滚动条
 */
export default {
  name: 'homeChannelZone',
  mixins: [adExposeMixin],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '频道专区'
    },
    /** 埋点 flowArea 前缀，如 channelZone */
    flow_area_prefix: {
      type: String,
      default: 'channelZone'
    }
  },
  data() {
    return {
      is_wx: isWeixin() ? 1 : 0
    }
  },
  mounted: function () {
    this.scheduleAdExposeBindHandle(this.bindCardsExposeHandle)
  },
  watch: {
    list: function () {
      this.scheduleAdExposeBindHandle(this.bindCardsExposeHandle)
    }
  },
  methods: {
    cardHandle(item, index) {
      this.$emit('banner-click', item, index, this.flow_area_prefix + '-' + (index + 1))
    },
    bindCardsExposeHandle: function () {
      var els = this.$refs.cardEls
      if (!els || !this.list.length) return
      if (!Array.isArray(els)) els = [els]
      for (var i = 0; i < els.length; i++) {
        if (els[i] && this.list[i]) {
          this.bindAdExposeHandle(els[i], this.flow_area_prefix + '-' + (i + 1), this.list[i])
        }
      }
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    }
  }
}
</script>

<style scoped lang="scss">
/* 单卡宽度：(视口 - 区块左右边距 - 滚动区内边距 - 两列间距) / 3 */
$strip: calc((100vw - 0.4rem) / 3);

.home_channel_zone {
  margin: 0.1rem 0.11rem 0;
  box-sizing: border-box;
}

.zone_header {
  padding: 0 0.1rem 0.1rem;
}

.zone_title {
  margin: 0;
  font-size: 0.22rem;
  font-weight: 700;
  color: #222;
  line-height: 1.3;
}

.zone_more {
  font-size: 0.12rem;
  color: #999;
  display: flex;
  align-items: center;
  gap: 0.02rem;
}

.scroll_row {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.scroll_inner {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.08rem;
  padding-bottom: 0.02rem;
  min-width: min-content;
}

.channel_card {
  flex: 0 0 $strip;
  width: $strip;
  overflow: hidden;
}

.channel_img_wrap {
  position: relative;
  width: 100%;
  padding-top: 121%;
}

.channel_img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.channel_caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0.06rem 0.06rem;
  font-size: 0.11rem;
  color: #fff;
  line-height: 1.3;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.55));
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeChannelZone.vue